{
    "version": 9,
    "layers": {
        "nation": {
            "name": "国家",
            "control": true,
            "hide": false,
            "order": -1,
            "z_index": 11,
            "version": 4,
            "minZoom": null,
            "maxZoom": 1,
            "markerType": "label",
            "style": {
                "color": "#ffffff",
                "icon": null
            }
        },
        "region": {
            "name": "政区",
            "control": true,
            "hide": false,
            "order": 0,
            "z_index": 10,
            "version": 5,
            "minZoom": 2,
            "maxZoom": null,
            "markerType": "label",
            "style": {
                "color": "#ffffff",
                "icon": null
            }
        },
        "village": {
            "name": "自然村",
            "control": true,
            "hide": false,
            "order": 1,
            "z_index": 9,
            "version": 2,
            "minZoom": 3,
            "maxZoom": null,
            "markerType": "label",
            "style": {
                "color": "#ffffff",
                "icon": null
            }
        },
        "office": {
            "name": "办事处",
            "control": true,
            "hide": false,
            "order": 2,
            "z_index": 9,
            "version": 2,
            "minZoom": 3,
            "maxZoom": null,
            "markerType": "label",
            "style": {
                "color": "#ffffff",
                "icon": null
            }
        },
        "central-department": {
            "name": "中央行政单位",
            "control": true,
            "hide": false,
            "order": 3,
            "z_index": 9,
            "version": 2,
            "minZoom": 4,
            "maxZoom": null,
            "markerType": "iconWithText",
            "style": {
                "color": "#e53935",
                "icon": "star"
            }
        },
        "department": {
            "name": "行政单位",
            "control": true,
            "hide": false,
            "order": 4,
            "z_index": 8,
            "version": 4,
            "minZoom": 4,
            "maxZoom": null,
            "markerType": "iconWithText",
            "style": {
                "color": "#e53935",
                "icon": "town-hall"
            }
        },
        "public-institution": {
            "name": "事业单位",
            "control": true,
            "hide": false,
            "order": 5,
            "z_index": 8,
            "version": 2,
            "minZoom": 4,
            "maxZoom": null,
            "markerType": "iconWithText",
            "style": {
                "color": "#f57c00",
                "icon": "building"
            }
        },
        "economic-unit": {
            "name": "经济单位",
            "control": true,
            "hide": false,
            "order": 6,
            "z_index": 8,
            "version": 2,
            "minZoom": 4,
            "maxZoom": null,
            "markerType": "iconWithText",
            "style": {
                "color": "#3574F0",
                "icon": "industry"
            }
        },
        "culture-tourism-unit": {
            "name": "文旅单位",
            "control": true,
            "hide": false,
            "order": 7,
            "z_index": 8,
            "version": 2,
            "minZoom": 4,
            "maxZoom": null,
            "markerType": "iconWithText",
            "style": {
                "color": "#388e3c",
                "icon": "attraction"
            }
        },
        "railway-station": {
            "name": "火车站",
            "control": true,
            "hide": false,
            "order": 8,
            "z_index": 9,
            "version": 1,
            "minZoom": 3,
            "maxZoom": null,
            "markerType": "iconWithText",
            "maps": ["satellite", "schematic"],
            "style": {
                "color": "#1565c0",
                "icon": "rail"
            }
        }
    }
}
